// extracted by mini-css-extract-plugin
module.exports = {"headline":"SummaryHeadline__headline--1Vq--","headlineLink":"SummaryHeadline__headlineLink--3EaH_","bounce":"SummaryHeadline__bounce--2fvO4"};